import { FormConfig } from '../../../../components/Form';

export const PRIVACY_POLICY_CONFIG: FormConfig = {
  description: {
    fieldType: 'richText',
    placeholder: 'Privacy Policy',
  },
};
